import { defineFcm } from '../shared/factory';

export const FCM_SUBSCRIPTION_COUNTRY_STAFF_COUNT = defineFcm('subscription_country_staff_count')
	.asNumber()
	.withDefault(0)
	.toConfig();
